<template>
  <div class="result w-full bg-white">

    <!-- GENERAL INFO -->

    <div id="info-card" class="bg-white px-4 py-6 mb-2">
      <h1 class="font-semibold text-2xl">
        {{ getRiskTitleFromLifeStage(lifeStageString) }}
        {{ babyWording }}
      </h1>
      <p class="text-base my-3">
        Apakah
        {{ lifeStageString === 'Ibu Hamil' || lifeStageString === 'Bulin & Bufas' ? 'Ibu' : 'Bayi' }}
        memiliki keluhan terkait bagian tubuh tertentu?
      </p>

      <BaseAccordion
        v-for="(item, index) in risks"
        :key="`health-marks-${index}`"
        class="mb-2">
        <template #title>{{ item.title }}</template>
        <!-- <template #desc>
          <p class="text-sm font-semibold mt-2" :class="`text-${colorHealth[index]}-darker`">
            {{ item.desc }}
          </p>
        </template> -->
        <template #body>
          <div v-for="(item2, index2) in item.list" :key="`itemList-${index}-${index2}`" class="bg-[#EDEDED] border-[1px] p-4 rounded-lg border-[#c3c3c3] my-2">
            <div class="title flex flex-row justify-between">
              <p class="text-base text-[#979797] font-semibold mb-3 text-left w-full me-3">{{ item2.title }}</p>
              <Checked v-if="item2.isChecked" class="w-5 h-5"/>
              <Unchecked v-else class="w-5 h-5"/>
            </div>
            <p class="text-base text-[#979797]">{{ item2.desc }}</p>
          </div>
        </template>
      </BaseAccordion>
    </div>

    <Loading v-show="loading" class="top-0 left-0 bg-[rgba(0,0,0,0.25)]"/>
  </div>
</template>

<script setup>
import {
  computed,
} from 'vue';

import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

import BaseAccordion from '@/components/accordion/BaseAccordion.vue';
import Loading from '@/components/LoadingOverlay.vue';
import Checked from '@/components/icons/Checked.vue';
import Unchecked from '@/components/icons/Unchecked.vue';

import { getAgeMonths } from '@/utilities/helpers';
// eslint-disable-next-line
import { getRisks, lifeStageType, getRiskTitleFromLifeStage } from '@/utilities/constants';

// const emit = defineEmits(['buyGold', 'completeProfile'])
const store = useStore();
const route = useRoute();

const userAgeMonths = computed(() => {
  const { dob } = store.state.global;
  return getAgeMonths(dob);
});

const babyWording = computed(() => {
  if (userAgeMonths.value > 1 && userAgeMonths.value <= 60) return '2-60 Bulan';
  if (userAgeMonths.value >= 0 && userAgeMonths.value <= 1) return '0-1 Bulan';
  return '';
});

const screeningResult = computed(() => {
  let result = store.state.screening.screeningData[store.state.screening.screeningIndex];
  if (route?.query?.page) {
    result = store.state.screening.screeningData[route?.query?.page - 1];
    store.dispatch('screening/setScreeningIndex', route?.query?.page - 1);
  }
  return result;
});
const lifeStageString = computed(() => lifeStageType(screeningResult.value?.lifeStage, screeningResult.value?.pregnancyStatus));

const results = computed(() => {
  let res = {};
  if (lifeStageString.value === 'Ibu Hamil') {
    res = screeningResult.value.pregnancyRisk || {};
  } else if (lifeStageString.value === 'Bulin & Bufas') {
    res = screeningResult.value.postpartumRisk || {};
  } else if (lifeStageString.value === 'Bayi' || lifeStageString.value === 'Anak - anak') {
    res = screeningResult.value.babyRisk || {};
  }
  return res;
});

const risks = computed(() => getRisks(lifeStageString.value, results.value, userAgeMonths.value));

</script>

<script>
export default {
  name: 'RiskDetailView',
};
</script>

<style lang="scss" scoped>

</style>
